import { render, staticRenderFns } from "./mortgage-insurance.vue?vue&type=template&id=0522997a"
import script from "./mortgage-insurance.vue?vue&type=script&lang=js"
export * from "./mortgage-insurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports